import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import { useUserActions } from "../store";
import type { LoginByQQData } from "../types";

export function useQQLoginMutation() {
  const { setToken } = useUserActions();

  return useMutation({
    mutationFn: (payload: LoginByQQData) => authApi.loginByQQ(payload),
    onSuccess: (response) => {
      setToken(response.token);
    },
  });
}
